<template>
  <div id="page">
    <h1>רשימת פרוייקטים</h1>
    <table class="center rtl tableWithTools" align="center" cellpadding="10" cellspacing="0">
      <thead>
        <tr>
          <th>שם <span class="oi" data-glyph="arrow-bottom"></span><span class="oi" data-glyph="arrow-top"></span></th>
          <th>כלים</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span class="oi colorLink isLink" data-glyph="link-intact"></span> בדיקה אחת שתיים שלוש</td>
          <td><span class="oi colorWarning isLink" data-glyph="pencil"></span>&nbsp;&nbsp;&nbsp;<span class="oi colorDanger isLink" data-glyph="trash"></span></td>
        </tr>
        <tr>
          <td><span class="oi colorLink isLink" data-glyph="link-intact"></span> בדיקה אחת שתיים שלוש</td>
          <td><span class="oi colorWarning isLink" data-glyph="pencil"></span>&nbsp;&nbsp;&nbsp;<span class="oi colorDanger isLink" data-glyph="trash"></span></td>
        </tr>
        <tr>
          <td><span class="oi colorLink isLink" data-glyph="link-intact"></span> בדיקה אחת שתיים שלוש</td>
          <td><span class="oi colorWarning isLink" data-glyph="pencil"></span>&nbsp;&nbsp;&nbsp;<span class="oi colorDanger isLink" data-glyph="trash"></span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  components: {},
  created() {},
  data() {
    return {};
  },
  methods: {},
  watch: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// Principal.vue?02e9c78d